import { useSyncExternalStore } from "react";

// The running quote analysis lives outside the wizard component so it
// survives navigation and tab reloads (persisted in localStorage).
// Shape: { jobId, userId, startedAt, stage, status: "processing"|"failed", error }
const KEY = "mp_active_analysis";
const listeners = new Set();

function read() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

let current = read();

function write(next) {
  current = next;
  try {
    if (next) localStorage.setItem(KEY, JSON.stringify(next));
    else localStorage.removeItem(KEY);
  } catch (e) {
    console.warn("[analysis] persist failed:", e?.message || e);
  }
  listeners.forEach((fn) => fn());
}

export const getActiveJob = () => current;
export const setActiveJob = (job) => write(job);
export const updateActiveJob = (patch) => current && write({ ...current, ...patch });
export const clearActiveJob = () => write(null);

function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function useActiveJob(userId) {
  const job = useSyncExternalStore(subscribe, getActiveJob);
  return job && job.userId === userId ? job : null;
}

// Quotes completed in this browser session get a "new" badge in the list.
const NEW_KEY = "mp_new_quotes";
export function markQuoteNew(id) {
  try {
    const ids = JSON.parse(sessionStorage.getItem(NEW_KEY) || "[]");
    sessionStorage.setItem(NEW_KEY, JSON.stringify([id, ...ids.filter((x) => x !== id)].slice(0, 10)));
  } catch { /* storage unavailable: badge is cosmetic */ }
}
export function isQuoteNew(id) {
  try {
    return JSON.parse(sessionStorage.getItem(NEW_KEY) || "[]").includes(id);
  } catch {
    return false;
  }
}
